import type { TFunction } from "i18next";

/** Round 16 A26 -- under a replay the answering model names itself
 * "replay of <the original>" and the configuration names the replay, so
 * every row read "is not the one configured" about a disagreement that
 * was the point of the run. Say which replay answered, and whose
 * answers it replays.
 *
 * Round 17 A32 -- one sentence for every seat: the examiner, the mock
 * exam and the run panel each carried their own wording, and only the
 * examiner's knew what a replay was. */
const REPLAY_PREFIX = /^replay of\s+/i;
export function modelsDifferSentence(
  t: TFunction,
  model: string,
  configured: string,
): string {
  if (REPLAY_PREFIX.test(model)) {
    return t("examiner.chain.modelsReplayed", {
      configured,
      original: model.replace(REPLAY_PREFIX, ""),
    });
  }
  return t("examiner.chain.modelsDiffer", { model, configured });
}
